/**
 * Api handlers for the App.
 * These will expose functions using the endpoints to call itslearning api's
 */
import { parameters, endpoints, messages } from './constants.js';

import { loginBanner, getStoreValue, updateStoreValue } from './store';

export const onSignIn = (response) => {
    const { settings, redirectData, ssoLoginSource, ssoLoginSources } = getStoreValue();
    const idToken = response.credential;

    if (typeof idToken === 'undefined') {
        return;
    }

    updateStoreValue({ IsInitialised: true, isUserSignedIn: true, googleUser: response });

    // Set isLoading after a timeout
    const isLoadingTimeout = setTimeout(() => { updateStoreValue({ isLoading: true }); }, 500);

    let gSuiteSsoEndpoint = settings.platformRestApiStartUrlSsl + endpoints.login;

    // if this is the chrome browser extension after logging in we want to redirect to our MVC view
    let { redirectLocationType } = getStoreValue();

    if (ssoLoginSource === ssoLoginSources.chromeBrowserExtension) {
        redirectLocationType = ssoLoginSources.chromeBrowserExtension;
    }

    if (redirectLocationType) {
        if (gSuiteSsoEndpoint.indexOf('?') > -1) {
            gSuiteSsoEndpoint += '&';
        } else {
            gSuiteSsoEndpoint += '?';
        }

        gSuiteSsoEndpoint = gSuiteSsoEndpoint + 'RedirectLocationType=' + redirectLocationType + '&RedirectData=' + redirectData;
    }

    const payload = JSON.stringify({ authToken: idToken, ssoLoginSource: ssoLoginSource });

    POST(gSuiteSsoEndpoint, payload)
        .then((response) => onResponse(response, isLoadingTimeout))
        .then(() => {
            if (!LoginBannerError()) {
                redirect();
            }
        })
        .catch(onError);
};

export function LoginBannerError() {
    const { ssoLoginSource, ssoLoginSources } = getStoreValue();
    const loginBannerValue = getStoreValue(loginBanner);

    let errorExists = true;

    if (ssoLoginSource === ssoLoginSources.chromeBrowserExtension) {
        if (loginBannerValue === 'GoogleSSONoAccountsFound') {
            updateStoreValue({ noConnectedAccount: true, isLoading: false });
        } else if (loginBannerValue === 'GoogleSSOMoreThanOneAccounts') {
            updateStoreValue({ multipleAccounts: true, isLoading: false });
        } else if (loginBannerValue === 'GoogleSSODisabled') {
            updateStoreValue({ ssoDisabled: true, isLoading: false });
        } else {
            errorExists = false;
        }
    } else {
        errorExists = false;
    }

    return errorExists;
}

export const onInitError = (error) => {
    const errorMessage = messages.errorInitGoogleApi
        .replace('{errorType}', error.error)
        .replace('{errorDetails}', error.details);

    console.log(errorMessage);
    updateStoreValue({ hasErrors: true });
};

const redirect = () => {
    const isDebug = getUrlParameter(parameters.debug);

    updateStoreValue({ isLoadCompleted: true, isLoading: false, isRedirecting: true });
    const { ssoInfos, itslearningLoginUrl, googleUser, ssoLoginSource, ssoLoginSources } = getStoreValue();
    const loginBannerValue = getStoreValue(loginBanner);

    const { loginBannerRequestItem } = getStoreValue().settings;

    let redirectUri = itslearningLoginUrl;

    if (ssoInfos.length === 1) {
        redirectUri = ssoInfos[0].ssoUri;
    }

    if (redirectUri.length > 0) {
        let timeout = 200;

        if (isDebug === 'true') {
            timeout = 100000;
            console.log(googleUser);
        }

        const url = new URL(redirectUri);

        if (loginBannerValue) {
            if (ssoLoginSource === ssoLoginSources.chromeBrowserExtension) {
                return; // dont redirect, we show the error on the page instead
            }

            url.searchParams.set(loginBannerRequestItem, loginBannerValue);
        }

        setTimeout(() => { window.location = url.href; }, timeout);
    }
};

const onResponse = (response, isLoadingTimeoutHandle) => {
    return new Promise((resolve, reject) => {
        if (response.status === 200) {
            response.json().then(data => {
                const siteNameAndSsos = [];

                for (let i = 0; i < data.siteAndSsoUri.length; i++) {
                    const siteNameAndSso = {
                        siteName: data.siteAndSsoUri[i].siteName,
                        ssoUri: data.siteAndSsoUri[i].ssoUri
                    };

                    siteNameAndSsos.push(siteNameAndSso);
                }

                updateStoreValue({
                    ssoInfos: siteNameAndSsos,
                    itslearningLoginUrl: data.itslearningLoginUrl,
                    errorCode: data.errorCode,
                });

                clearTimeout(isLoadingTimeoutHandle);
                resolve();
            });
        } else {
            reject(response);
        }
    });
};

const onError = (error) => {
    console.log('Error occurred ' + error);
    updateStoreValue({ isLoadCompleted: true, isLoading: false, ssoInfos: [], hasErrors: true });
};

const POST = function (uri, payload) {
    return fetch(uri, {
        body: payload,
        credentials: 'same-origin',
        method: 'POST',
        headers: {
            'Content-Type': 'text/json',
            'cache-control': 'no-store'
        }
    });
};

const getUrlParameter = (name) => {
    name = name.replace(/[[]/, '\\[').replace(/[\]]/, '\\]');
    const regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    const results = regex.exec(location.search);

    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
};
